"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Question = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _reactSlick = _interopRequireDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

var _Loader = _interopRequireDefault(require("./Loader"));

var _QuestionForm = _interopRequireDefault(require("./QuestionForm"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 15px;\n    justify-content: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    padding: 10px;\n    text-align: center;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    overflow: hidden;\n    display: inline-block;\n    border: 1px solid ", ";\n    font-size: 12px;\n    padding: 10px 15px;\n    position: relative;\n    font-weight: bold;\n    background: ", ";\n    color: ", ";\n    cursor: ", ";\n\n    &:hover {\n        background: ", ";\n        color: ", ";\n    }\n    &:before {\n        content: '';\n        width: calc(100% + 2px);\n        height: calc(100% + 2px);\n        position: absolute;\n        top: -1px;\n        left: -1px;\n        background: ", ";\n        opacity: .2;\n    }\n    &:focus {\n        outline: none;\n    }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    text-align: center;\n    color: #676767;\n    font-size: 12px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 10px;\n    .slick-slide > div > div:focus {\n        outline: none;\n    }\n    .slick-dots {\n        position: static;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding: 15px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 15px;\n    font-size: 1.3em;\n    line-height: 1.5em;\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    * {\n        margin: 0;\n        color: inherit;\n    }\n    @media (max-width: 767px) {\n        margin: 0 -10px;\n        padding: 15px 20px;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background: #fff;\n    font-family: ", ";\n    font-weight: 300;\n    @media (max-width: 767px) {\n        border: none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var QuestionContainer = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var fontFamily = _ref.fontFamily;
  return fontFamily || "'Geometria', sans-serif";
});

var QuestionTitle = _styledComponents["default"].div(_templateObject2(), function (_ref2) {
  var background = _ref2.background;
  return background || '#2b3d4f';
}, function (_ref3) {
  var color = _ref3.color;
  return color || '#fff';
});

var QuestionFooter = _styledComponents["default"].div(_templateObject3());

var QuestionsPagination = _styledComponents["default"].div(_templateObject4());

var FooterText = _styledComponents["default"].div(_templateObject5());

var PaginationButton = _styledComponents["default"].a(_templateObject6(), function (_ref4) {
  var bg = _ref4.bg;
  return bg || '#2b3d4f';
}, function (_ref5) {
  var answered = _ref5.answered,
      bg = _ref5.bg;
  return answered ? bg || '#2b3d4f' : 'transparent';
}, function (_ref6) {
  var answered = _ref6.answered;
  return answered ? '#fff' : '#2b3d4f';
}, function (_ref7) {
  var current = _ref7.current,
      disallowed = _ref7.disallowed;
  return disallowed ? 'not-allowed' : current ? 'default' : 'pointer';
}, function (_ref8) {
  var current = _ref8.current,
      answered = _ref8.answered,
      disallowed = _ref8.disallowed,
      bg = _ref8.bg;
  return answered ? bg || '#f54d2e' : current && !answered || disallowed ? 'transparent' : '#ccc';
}, function (_ref9) {
  var answered = _ref9.answered;
  return answered ? '#fff' : '#2b3d4f';
}, function (_ref10) {
  var current = _ref10.current,
      bg = _ref10.bg;
  return current ? bg || '#2b3d4f' : 'transparent';
});

var ErrorContainer = _styledComponents["default"].div(_templateObject7());

var LoaderContainer = _styledComponents["default"].div(_templateObject8());

var sliderSettings = function sliderSettings() {
  var initialSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    arrows: false,
    dots: true,
    infinite: false,
    slidesToShow: 17,
    slidesToScroll: 17,
    initialSlide: initialSlide,
    responsive: [[300, 4], [400, 5], [480, 6], [500, 8], [600, 9], [700, 10], [800, 12], [900, 14], [1000, 16]].map(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          breakpoint = _ref12[0],
          slidesToShow = _ref12[1];

      return {
        breakpoint: breakpoint,
        settings: {
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToShow
        }
      };
    })
  };
};

var Question = /*#__PURE__*/function (_Component) {
  _inherits(Question, _Component);

  var _super = _createSuper(Question);

  function Question() {
    var _this;

    _classCallCheck(this, Question);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isAnswered", function (i) {
      return (0, _ramda.contains)((0, _ramda.path)([i - 1], _this.props.stat), ['answered', 'expired']);
    });

    _defineProperty(_assertThisInitialized(_this), "renderPagination", function () {
      var _this$props = _this.props,
          colors = _this$props.colors,
          questionNum = _this$props.questionNum,
          respondent = _this$props.respondent,
          questionsCount = _this$props.questionsCount,
          isAudit = _this$props.isAudit,
          onChangePage = _this$props.onChangePage,
          _this$props$translate = _this$props.translate,
          translate = _this$props$translate === void 0 ? {} : _this$props$translate;
      var count = respondent.questionsCount || questionsCount;
      var questions = (0, _ramda.range)(1, count + 1);
      return /*#__PURE__*/_react["default"].createElement(QuestionFooter, null, /*#__PURE__*/_react["default"].createElement(QuestionsPagination, null, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], sliderSettings(Math.floor((questionNum - 1) / 16) * 16), questions.map(function (i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "question-".concat(i)
        }, /*#__PURE__*/_react["default"].createElement(PaginationButton, {
          current: i === questionNum,
          answered: _this.isAnswered(i),
          disallowed: !respondent.skipQuestionsAllowed,
          bg: colors.input,
          onClick: function onClick() {
            return !respondent.skipQuestionsAllowed ? null : onChangePage && onChangePage(i);
          }
        }, i));
      }))), /*#__PURE__*/_react["default"].createElement(FooterText, null, questionNum, " ", (0, _ramda.path)(['questionMessage'], translate) || 'вопрос из', " ", (0, _ramda.pathOr)(1, ['questionsCount'], respondent)));
    });

    return _this;
  }

  _createClass(Question, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          respondent = _this$props2.respondent,
          question = _this$props2.question,
          questionMeta = _this$props2.questionMeta,
          colors = _this$props2.colors,
          fontFamily = _this$props2.fontFamily,
          additionalFormFields = _this$props2.additionalFormFields,
          responseType = _this$props2.responseType,
          id = _this$props2.id,
          num = _this$props2.num,
          finishTest = _this$props2.finishTest,
          formAction = _this$props2.formAction,
          skipUrl = _this$props2.skipUrl,
          pauseAllowed = _this$props2.pauseAllowed,
          onSubmitSuccess = _this$props2.onSubmitSuccess,
          finishAfterAnswer = _this$props2.finishAfterAnswer,
          setPaused = _this$props2.setPaused,
          translate = _this$props2.translate,
          isAudit = _this$props2.isAudit;
      var loading = questionMeta.pending && !questionMeta.lastSucceedAt;
      return /*#__PURE__*/_react["default"].createElement(QuestionContainer, {
        fontFamily: fontFamily
      }, /*#__PURE__*/_react["default"].createElement(QuestionTitle, {
        color: colors.questionHeaderText,
        background: colors.questionHeader
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "question-title",
        dangerouslySetInnerHTML: {
          __html: question.title
        }
      })), questionMeta.error && /*#__PURE__*/_react["default"].createElement(ErrorContainer, null, /*#__PURE__*/_react["default"].createElement(PaginationButton, null, (0, _ramda.path)(['errorMessage'], translate) || 'Ошибка. Не удалось загрузить вопрос')), loading ? /*#__PURE__*/_react["default"].createElement(LoaderContainer, null, /*#__PURE__*/_react["default"].createElement(_Loader["default"], null)) : questionMeta.lastSucceedAt && /*#__PURE__*/_react["default"].createElement(_QuestionForm["default"], {
        key: question.num,
        translate: translate,
        data: question,
        respondent: respondent,
        responseType: responseType,
        isAudit: isAudit,
        formAction: formAction,
        finishTest: finishTest,
        skipUrl: skipUrl,
        pauseAllowed: pauseAllowed,
        onSubmitSuccess: onSubmitSuccess,
        defaultError: (0, _ramda.path)(['defaultErrorMessage'], translate) || 'Не удалось отправить ответ на сервер',
        setPaused: setPaused,
        colors: colors,
        initialValues: _objectSpread(_objectSpread({}, (0, _ramda.pathEq)(['comment', 'complexity'], null, question) ? {
          complexity: ''
        } : question.comment), {}, {
          type: question.type,
          id: id,
          num: num,
          finishAfterAnswer: finishAfterAnswer,
          isExpert: !!question.auditComment
        }, isAudit ? {
          complexity: question.complexity
        } : {
          answerVariantId: question.answerVariantId,
          answerVariantIds: question.answerVariantIds
        }),
        additionalFormFields: additionalFormFields,
        pagination: this.renderPagination()
      }));
    }
  }]);

  return Question;
}(_react.Component);

exports.Question = Question;

_defineProperty(Question, "defaultProps", {
  colors: {},
  respondent: {
    skipQuestionsAllowed: true
  },
  question: {},
  questionsCount: 0,
  questionNum: 1,
  questionMeta: {
    lastSucceedAt: true
  },
  responseType: 'respondents',
  translate: {},
  isAudit: false
});